export default __webpack_public_path__ + "08412f8238d3377bc080f9a46bb9d9d8.png";